/**
 * @generated SignedSource<<897b8c2cc35caadc9c57b1d4f0cab436>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClipsPanelRenameClipMutation$variables = {
  clipId: string;
  title: string;
};
export type ClipsPanelRenameClipMutation$data = {
  readonly renameClip: {
    readonly clip: {
      readonly id: string;
      readonly lastEditedBy: {
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly title: string;
    };
    readonly error: string | null;
  } | null;
};
export type ClipsPanelRenameClipMutation$rawResponse = {
  readonly renameClip: {
    readonly clip: {
      readonly id: string;
      readonly lastEditedBy: {
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly title: string;
    };
    readonly error: string | null;
  } | null;
};
export type ClipsPanelRenameClipMutation = {
  rawResponse: ClipsPanelRenameClipMutation$rawResponse;
  response: ClipsPanelRenameClipMutation$data;
  variables: ClipsPanelRenameClipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clipId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "clipId",
        "variableName": "clipId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "RenameClip",
    "kind": "LinkedField",
    "name": "renameClip",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecordingClip",
        "kind": "LinkedField",
        "name": "clip",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "lastEditedBy",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClipsPanelRenameClipMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClipsPanelRenameClipMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7a4fbb96a11827f103940051c5589d88",
    "id": null,
    "metadata": {},
    "name": "ClipsPanelRenameClipMutation",
    "operationKind": "mutation",
    "text": "mutation ClipsPanelRenameClipMutation(\n  $clipId: ID!\n  $title: String!\n) {\n  renameClip(clipId: $clipId, title: $title) {\n    clip {\n      id\n      title\n      lastEditedBy {\n        id\n        fullName\n      }\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "dd1fe86b3e6b806652f444f5fa912418";

export default node;
